import { Component, OnInit, HostBinding, Input, OnChanges, OnDestroy, ViewChild, ChangeDetectorRef, AfterViewChecked } from '@angular/core';
import { AerovalesService } from '../aerovales.service';
import { Aerovale } from '@shared/models/despacho/Aerovale';
import { NgxSpinnerService } from 'ngx-spinner';
import { AerovaleDetalle } from '@shared/models/despacho/AerovaleDetalle';
import { EstadoAerovale } from '@shared/enums/estadoAerovale';
import { UsuarioService } from '@account/usuario.service';
import { UntypedFormControl, AbstractControl } from '@angular/forms';
import { NgbDateStruct, NgbCalendar, NgbModal, NgbDatepickerConfig, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { SharedService } from '@shared/shared.service';
import { fadeAnimationTrigger } from '@shared/animations';
import { DatePipe } from "@angular/common";
import { environment } from '@environments';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { saveAs } from 'file-saver';
import { ModalAnulacionAerovaleComponent } from '../modal-anulacion-aerovale/modal-anulacion-aerovale.component';
import { MessageService } from '@shell/message.service';
import { SeleccionTipoAerovaleComponent } from '../aerovales/seleccion-tipo-aerovale/seleccion-tipo-aerovale.component';
import { TipoAerovale } from '@shared/enums/tipoAerovale';
import { Comprobante } from '@shared/models/facturacion/Comprobante';
import { Remito } from '@shared/models/facturacion/Remito';
import { TipoUsuario } from '@shared/enums/tipoUsuario';
import { AuthService } from '@authentication/auth.service';
import { ComprobanteService } from '@facturacion/comprobante.service';
import { ImporteFacturaComponent } from '@shared/importe-factura/importe-factura.component';
import { ImporteFactura } from '@shared/models/facturacion/ImporteFactura';
import { EstadoFactura } from '@shared/enums/EstadoFactura';
import { ModalOkComponent } from '@shared/generic-modals/modal-ok.component';
import { TipoPago } from '@shared/enums/tipoPago';
import { VisorRemitoAerovaleComponent } from '../visor-remito-aerovale/visor-remito-aerovale.component';
import { RemitoFox } from '@shared/models/despacho/RemitoFox';
import { ModalCreacionFoxComponent } from '../modal-creacion-fox/modal-creacion-fox.component';
import { ModalConfirmComponent } from '@shared/generic-modals/modal-confirm.component';
import { AerovaleUpdatedCommonComponent } from '../aerovales-update/aerovale-updated-common/aerovale-updated-common.component';
import { AerovaleUpdatedAerocombustibleComponent } from '../aerovales-update/aerovale-updated-aerocombustible/aerovale-updated-aerocombustible.component';
import { AerovaleUpdatedAlijeComponent } from '../aerovales-update/aerovale-updated-alije/aerovale-updated-alije.component';
import { EstadoAutorizacionAev } from '@shared/enums/EstadoAutorizacionAev';
import { ErrorModel } from '@shared/models/ErrorModel';
import { RefacturacionFactura } from '@shared/models/facturacion/RefacturacionFactura';
import { FacturacionService } from '@facturacion/facturacion.service';
import { AerovaleDetalleComponent } from '@despacho/aerovale-detalle/aerovale-detalle.component';
import html2canvas from 'html2canvas';
import { RolesService } from '@shared/services/roles.service';
import { TipoSolicitudRefacturacion } from '@shared/enums/facturacion/TipoSolicitudRefacturacion';

@Component({
  selector: 'app-visor-aerovales',
  templateUrl: './visor-aerovales.component.html',
  styleUrls: ['./visor-aerovales.component.css'],
  animations: [fadeAnimationTrigger]
})

export class
  VisorAerovalesComponent implements OnInit, OnChanges, OnDestroy, AfterViewChecked {

  @HostBinding('class.changed')

  aeroplantaPuedeFacturar: boolean = false;
  fileAerovaleFisico:File;
  TipoPago = TipoPago;
  TipoUsuario = TipoUsuario;

  importeFactura: ImporteFactura;

  baseUrl = environment.apiServer.baseUrl;
  aerovales: Aerovale[] = [];
  aerovalesFiltrados: Aerovale[] = [];
  aerovaleActual: Aerovale;
  aerovaleDetalle: AerovaleDetalle;
  fechaHasta = new UntypedFormControl();
  fechaFormControlDesdeHasta = new UntypedFormControl();
  mensajeErrorExportar = "";
  model: NgbDateStruct;
  model1: NgbDateStruct;
  time: NgbTimeStruct;
  startDate: Date;
  endDate: Date;
  buscando: boolean = false;
  mensajeSpinner: string = "D e s c a r g a n d o";
  obteniendoAerovales = true;
  obteniendoComprobante = true;
  procesandoExport: boolean = false;
  codigoAeroplanta: string;
  cambiandoAeroplanta: boolean = false;
  pendiente = { valor: "Pendiente", descripcion: "Pendiente", seleccionado: false };
  finalizado = { valor: "Finalizado", descripcion: "Finalizado", seleccionado: false };
  finalizadoSinFirma = { valor: "FinalizadoSinFirma", descripcion: "Finalizado sin firma", seleccionado: false };
  estadoSincronizado = { valor: "Sincronizado", descripcion: "Sincronizado", seleccionado: false };
  anulado = { valor: "Anulado", descripcion: "Anulado", seleccionado: false };

  aerovaleAerocombustible = { tipo: 0, valor: "AerovaleAerocombustible", descripcion: "Aerovale Aerocombustible", seleccionado: false };
  aerovaleAeroespecialidad = { tipo: 1, valor: "AerovaleAeroespecialidad", descripcion: "Aerovale Aeroespecialidad", seleccionado: false };
  aerovaleCombustible = { tipo: 2, valor: "AerovaleCombustible", descripcion: "Aerovale Combustible", seleccionado: false };
  aerovaleAelije = { tipo: 3, valor: "AerovaleAlije", descripcion: "Aerovale Alije", seleccionado: false };
  aerovaleDevolucion = { tipo: 5, valor: "AerovaleDevolucion", descripcion: "Aerovale Devolucion", seleccionado: false };
  tipos = [
    this.aerovaleAerocombustible, this.aerovaleAelije, this.aerovaleCombustible, this.aerovaleAeroespecialidad, this.aerovaleDevolucion,
  ];

  estados = [
    this.pendiente,
    this.finalizado,
    this.estadoSincronizado,
    this.anulado
  ];
  busquedaFormControl = new UntypedFormControl();
  change$: Subscription;
  errorAerovales: boolean = false;
  tipoNuevoAerovale: TipoAerovale;
  TipoAerovale = TipoAerovale;
  EstadoAerovale = EstadoAerovale;
  EstadoAutorizacionAev = EstadoAutorizacionAev;
  @Input() facturaObtenida: Comprobante;
  remito: Remito;
  mostrarBotonFacturarAerovale: boolean;
  botonAnular: boolean = false;

  remitoObtenido: Comprobante;
  remitoFox: RemitoFox;
  buscandoComprobante: boolean = false;
  capturandoAevAnulado: boolean = false;
  procesandoSolicitud: boolean = false;
  procesandoAnulacion: boolean = false;
  regenerandoAerovale: boolean = false;
  mostrarRegenerarIATA: boolean = false;
  //puedeFacturarAerovale: boolean = false;

  soloReemplazar: boolean = false;
  solicitaRefacturacion: boolean = false;

  @ViewChild(AerovaleDetalleComponent) aerovaleDetalleComponent: AerovaleDetalleComponent;

  constructor(private datepickerConfig2: NgbDatepickerConfig,
    private messageService: MessageService,
    private aerovaleService: AerovalesService,
    private usuarioService: UsuarioService,
    private calendar: NgbCalendar,
    private spinner: NgxSpinnerService,
    private sharedService: SharedService,
    private modalService: NgbModal,
    private http: HttpClient,
    private datePipe: DatePipe,
    private modalAnulacion: NgbModal,
    private comprobanteService: ComprobanteService,
    private facturacionService: FacturacionService,
    private rolesService: RolesService,
    private changeDetector: ChangeDetectorRef,
    public authService: AuthService) {
      this.change$ = sharedService.aeroplantaSeleccionada.subscribe(()=>{
        this.cambiarDeAeroplanta();
      });
  }

  ngOnInit() {
    this.buscandoComprobante = false;
    this.codigoAeroplanta = this.usuarioService.getAeroplantaActual().codigoAeroplanta;
    this.aeroplantaPuedeFacturar = this.usuarioService.getAeroplantaActual().habilitarFacturacion || this.usuarioService.getAeroplantaActual().soloPAD;
    this.mostrarBotonFacturarAerovale = true;
    this.botonAnular = false;
    this.mensajeSpinner = "C a r g a n d o . . .";
    
    this.model = this.calendar.getToday();
    this.model1 = this.calendar.getToday();
    const inicio: any = { day: 1, month: 1, year: 2019 };
    this.datepickerConfig2.minDate = inicio;
    const fin: any = { day: this.model.day, month: this.model.month, year: this.model.year };
    this.model1 = this.calendar.getToday();
    this.datepickerConfig2.maxDate = fin;
    setTimeout(() => {
      this.spinner.show('spinnerLista');
    });
    this.reinicioFechaInicioFechaFin();
    this.getAerovalesPorRango(this.startDate, this.endDate);
    this.obtenerRemitos();
  }

  ngOnChanges(): void {
    this.ngOnInit();
  }

  ngAfterViewChecked() {
    this.changeDetector.detectChanges();
  }

  onSelect(aerovale: Aerovale): void {
    this.remitoFox = null;
    this.buscandoComprobante = true;
    this.obteniendoComprobante = true;
    this.capturandoAevAnulado = false;
    setTimeout(() => {
      this.spinner.show('spinnerLista');
    });
    this.facturaObtenida = null; //inicializo el comprobante en null en cada seleccion
    this.spinner.show('spinnerDetalle');
    this.aerovaleDetalle = null;
    this.aerovaleActual = aerovale;
    this.aerovaleService.getAerovalePorIdyTipo(this.aerovaleActual.id)
      .subscribe(aerovaleDetalle => {
        this.aerovaleDetalle = aerovaleDetalle;        
        this.spinner.hide('spinnerDetalle');
        this.obtenerRemitos();
      });
  }

  sincronizable(aerovale: AerovaleDetalle): boolean {
    const estadoAev: EstadoAerovale = EstadoAerovale[aerovale.estado];
    switch (estadoAev) {
      case EstadoAerovale.Precargado:
      case EstadoAerovale.DespachoIniciado:
      case EstadoAerovale.DespachoFinalizado:
      case EstadoAerovale.Pendiente:
      case EstadoAerovale.Sincronizado:
      case EstadoAerovale.Anulado:
        return false;

      case EstadoAerovale.Finalizado:
      case EstadoAerovale.FinalizadoSinFirma:
        return true;
    }
  }

  sincronizado(aerovale: AerovaleDetalle): boolean {
    const estadoAev: EstadoAerovale = EstadoAerovale[aerovale.estado];
    if (estadoAev === EstadoAerovale.Sincronizado) {
      return true;
    }
    else {
      return false;
    }
  }

  sincronizar(aev: AerovaleDetalle): void {
    this.spinner.show('spinnerDetalle');

    this.aerovaleService.sincronizar(aev.id)
      .subscribe(response => {
        this.aerovaleActual.estado = response.estado;
        this.aerovaleDetalle.estado = response.estado;
        this.spinner.hide('spinnerDetalle');
      });
  }

  aeroplantaSoloPad(){    
    return this.usuarioService.getAeroplantaActual().soloPAD;
  }

  print(): void {
    const printContents = document.getElementById('aerovalePrint').innerHTML;
    this.sharedService.print(printContents);
  }

  filtrarAerovales() {
    this.aerovalesFiltrados = this.aerovales.filter(a => {
      let agregar = true;
      if (this.busqueda.value) {
        agregar = a.clienteRazonSocial.toLowerCase().indexOf(this.busqueda.value.toLowerCase()) > -1;
        agregar = agregar || (a.nombreCiudadAeropuerto &&
          a.nombreCiudadAeropuerto.toLowerCase().indexOf(this.busqueda.value.toLowerCase()) > -1);
        agregar = agregar || (a.vuelo && a.vuelo.toLowerCase().indexOf(this.busqueda.value.toLowerCase()) > -1);
        agregar = agregar || (a.matricula && a.matricula.toLowerCase().indexOf(this.busqueda.value.toLowerCase()) > -1);
        agregar = agregar || (a.numeroAerovale && a.numeroAerovale.toString().indexOf(this.busqueda.value) > -1);

      }
      if (this.estados.some(b => b.seleccionado))
        agregar = agregar && this.estados.some(
          b => (b.seleccionado && b.valor == a.estado) ||
            (b.seleccionado && b == this.finalizado && this.finalizadoSinFirma.valor == a.estado));
      if (this.tipos.some(b => b.seleccionado))
        agregar = agregar && this.tipos.some(
          b => (b.seleccionado && b.tipo == a.tipoAerovale));
      return agregar;
    });
    if (this.aerovaleActual) {
      if (!this.aerovalesFiltrados.includes(this.aerovaleActual)) {
        this.aerovaleDetalle = null;
      }
    }
  }

  get busqueda() {
    return this.busquedaFormControl;
  }

  getAerovalesPorRango(fechaInicio: Date, fechaFin: Date) {
    this.obteniendoAerovales = true;
    this.aerovales = [];
    this.aerovalesFiltrados = [];
    this.spinner.show('spinnerLista');
    const desde: string = this.sharedService.formatDate(fechaInicio.getFullYear(), fechaInicio.getMonth() + 1, fechaInicio.getDate(), 0, 0);
    const hasta: string = this.sharedService.formatDate(fechaFin.getFullYear(), fechaFin.getMonth() + 1, fechaFin.getDate(), 23, 59);
    this.aerovaleService.getAerovalesPorRangoEnAeroplantas(desde, hasta)
      .subscribe(result => {
        this.aerovales = result.sort((a, b) => new Date(b.fechaHoraFinDespacho).getTime() - new Date(a.fechaHoraFinDespacho).getTime());
        this.aerovalesFiltrados = result;
        this.spinner.hide('spinnerLista');
        this.obteniendoAerovales = false;
        this.filtrarAerovales();
      }, () => {
        this.errorAerovales = true;
        this.obteniendoAerovales = false;
      });
  }

  export() {

    this.spinner.show('spinnerLista');
    this.obteniendoAerovales = true;
    this.procesandoExport = true;
    this.aerovalesFiltrados = null;
    this.aerovaleActual = null;
    this.aerovaleDetalle = null;
    this.mensajeSpinner = " D e s c a r g a n d o ...";
    this.startDate = new Date(this.model.year, this.model.month - 1, this.model.day);
    this.endDate = new Date(this.model1.year, this.model1.month - 1, this.model1.day);
    this.endDate.setHours(23, 59, 59, 99);

    if (this.mostrarResultados() === true) {

      this.exportarAerovalesPorRango(this.startDate, this.endDate);
      this.spinner.hide('spinnerLista');
    }
    else {

      this.aerovalesFiltrados.splice(0, this.aerovalesFiltrados.length);
    }
    this.obteniendoAerovales = false;
    this.procesandoExport = false;
  }

  exportarAerovalesPorRango(fechaInicio: Date, fechaFin: Date) {
    this.mensajeErrorExportar = "";
    const fechaDesde = this.sharedService.formatDate(fechaInicio.getFullYear(), fechaInicio.getMonth() + 1, fechaInicio.getDate(), fechaInicio.getHours(), fechaInicio.getMinutes());
    const fechaHasta = this.sharedService.formatDate(fechaFin.getFullYear(), fechaFin.getMonth() + 1, fechaFin.getDate(), fechaFin.getHours(), fechaFin.getMinutes());
    const url = `${this.baseUrl}/AerovalesV2/${this.codigoAeroplanta}/Exportar?fechaDesde=${fechaDesde}&fechaHasta=${fechaHasta}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    });
    // Process the file downloaded
    this.http.get(url, { headers: headers, responseType: 'blob' as 'json' })
      .subscribe((res: Blob) => {
        const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' });
        const fInicio = this.datePipe.transform(fechaInicio, 'dd-MM-yyyy');
        const fFin = this.datePipe.transform(fechaFin, 'dd-MM-yyyy');
        saveAs(blob, "aerovalesDesde" + fInicio + "al" + fFin);
        this.procesandoExport = false;
        this.spinner.hide('spinnerLista');
      }, () => {        
        this.mensajeErrorExportar = "No puede exportar excel sin aerovales";
      });
  }

  ngOnDestroy() {
    this.change$.unsubscribe(); // cambia aeroplanta
    this.aerovalesFiltrados = [];
  }

  addValidationError(control: AbstractControl, validationName: string) {
    let errors = control.errors;
    if (errors == null)
      errors = { [validationName]: true };
    else
      errors[validationName] = true;
    control.setErrors(errors);
    control.markAsDirty();
  }

  /**
   * Convierte una NgbDateStruct y una NgbTimeStruct en un Date
   */
  dateFromDateTimeStruct(date: NgbDateStruct, hour: NgbTimeStruct): Date {
    if (date == null || hour == null)
      return null;
    const dateReturn = new Date();
    dateReturn.setDate(date.day);
    dateReturn.setMonth(date.month - 1);
    dateReturn.setFullYear(date.year);
    dateReturn.setHours(hour.hour);
    dateReturn.setMinutes(hour.minute);
    return dateReturn;
  }

  fechaDesdeMayorQueHasta() {
    let esMayor: boolean = false;
    this.startDate = new Date(this.model.year, this.model.month - 1, this.model.day);
    this.endDate = new Date(this.model1.year, this.model1.month - 1, this.model1.day);
    if (this.startDate > this.endDate) { esMayor = true; }
    return esMayor;
  }


  reinicioFechaInicioFechaFin() {
    this.startDate = new Date(this.model.year, this.model.month - 1, this.model.day);
    this.endDate = new Date(this.model1.year, this.model1.month - 1, this.model1.day);
    this.endDate.setHours(23, 59, 59, 99);
  }

  buscarDesdeHasta() {
    this.mensajeErrorExportar = "";
    this.aerovalesFiltrados = null;
    this.aerovaleActual = null;
    this.aerovaleDetalle = null;
    this.mensajeSpinner = "C a r g a n d o . . .";
    this.buscando = true;
    this.reinicioFechaInicioFechaFin();
    if (this.mostrarResultados() === true) {
      this.getAerovalesPorRango(this.startDate, this.endDate);
    }
    else {
      this.aerovalesFiltrados.splice(0, this.aerovalesFiltrados.length);
    }
    this.buscando = false;
  }

  mostrarResultados() {
    let mostrar: boolean;
    mostrar = false;
    mostrar = (this.startDate < this.endDate);
    return mostrar;
  }

  limpiarCampos() {
    this.aerovalesFiltrados = [];
    this.aerovaleDetalle = null;
    this.spinner.hide("spinnerLista");
    this.spinner.hide("spinnerDetalle");
    this.buscando = false;
    this.busquedaFormControl.reset();
    this.model = this.calendar.getToday();
    this.model1 = this.calendar.getToday();
    //limpio filtro estados
    for (const estado of this.estados) {
      estado.seleccionado = false;
    }
    //limpio filtro tipos
    for (const tipo of this.tipos) {
      tipo.seleccionado = false;
    }
  }

  cambiarDeAeroplanta() {
    this.cambiandoAeroplanta = false;
    this.limpiarCampos();
    this.cambiandoAeroplanta = true;
    this.ngOnInit();
  }

  crearNuevoAerovale() {
    const modalRef = this.modalService.open(SeleccionTipoAerovaleComponent, { size: 'lg', backdrop: 'static' });
    modalRef.result.then((tipoAerovale) => {
      this.tipoNuevoAerovale = tipoAerovale;
      this.aerovales = null;
      this.aerovalesFiltrados = null;
    }).catch((error) => {
      console.log(error);
    });
  }

  irAImporteDeFactura() {
    const modalRef = this.modalService.open(ImporteFacturaComponent, { centered: true, size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.aerovaleAfacturar = this.aerovaleDetalle;
    modalRef.result.then((res) => {
      if (res === 'FACTURADO') {
        this.onSelect(this.aerovaleActual)
      }
    });
  }

  auditoriaAforadores() {
    const modalRef = this.modalService.open(ModalOkComponent, { centered: true });
    modalRef.componentInstance.titulo = "Auditoria de aforadores";

    let mensaje = "";

    if (this.aerovaleDetalle.detalleAerocombustible.aforadorInicialEditado) {
      mensaje += "Aforador Inicial: EDITADO MANUALMENTE<br/><br/>";
    } else {
      mensaje += "Aforador Inicial: LEIDO DE CAUDALIMETRO<br/><br/>";
    }

    if (this.aerovaleDetalle.detalleAerocombustible.aforadorFinalEditado) {
      mensaje += "Aforador final: EDITADO MANUALMENTE";
    } else {
      mensaje += "Aforador final: LEIDO DE CAUDALIMETRO";
    }

    modalRef.componentInstance.mensaje = mensaje;
  }

  auditoriaAutorizaciones() {
    const modalRef = this.modalService.open(ModalOkComponent, { centered: true });
    modalRef.componentInstance.titulo = "Auditoria de autorizaciones";
    const mensaje = EstadoAutorizacionAev[this.aerovaleDetalle.estadoAutorizacion];
    modalRef.componentInstance.mensaje = "Estado de autorización: " + mensaje;
  }

  anularAerovale(detalle: AerovaleDetalle) {    
    if(this.aerovaleDetalle.estado == "DespachoIniciado" || this.aerovaleDetalle.estado == "DespachoFinalizado" || this.aerovaleDetalle.estado == "Pendiente"){
      const modalRef = this.modalService.open(ModalConfirmComponent, { centered: true });
      modalRef.componentInstance.mensaje = "Esta anulando un aerovale en estado " + this.aerovaleDetalle.estado + ". Este aerovale aún no genero remito de stock ni de facturacion. ¿Esta seguro de anularlo?"; 
      modalRef.result.then(() => {
        this.accionAnularAerovale(detalle);
      });
    }else{
      this.accionAnularAerovale(detalle);
    }
  }

  accionAnularAerovale(detalle: AerovaleDetalle){
    this.obtenerAerovalePorId(detalle.id);
    const modalRef = this.modalAnulacion.open(ModalAnulacionAerovaleComponent, { centered: true, size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.detalle = detalle;
    modalRef.result.then(() => {
      this.onSelect(this.aerovaleActual);
    });
  }

  regenerarAerovaleIATA() {
    this.regenerandoAerovale = true;
    this.aerovaleService.regenerarAerovaleIATA({aerovaleOriginalId: this.aerovaleDetalle.id}).subscribe(a => {
      if(a) {
        this.messageService.showSuccessMessage("El aerovale se ha regenerado con éxito")
      }
      this.regenerandoAerovale = false;
      this.onSelect(this.aerovaleActual);
    }, (err: ErrorModel) => {
      this.messageService.showErrorMessage("Ha habido un error: "+ err.description);
      this.regenerandoAerovale = false;
    })
  }

  /**
   * @param anulaYReemplaza boolean para mostrar marca de "anulado"
   * @param solicitaRefacturacion opcional, iniciar flujo de refacturacion
   * @param reemplazaSupervisor boolean para el rol supervisor si necesita anular y reemplazar
   */
  iniciarAnulacionYReemplazo(anulaYReemplaza: boolean, solicitaRefacturacion = false, reemplazaSupervisor = false) {
    this.capturandoAevAnulado = true;
    if (!solicitaRefacturacion) {
      this.soloReemplazar = !anulaYReemplaza;
      this.iniciarFlujoDeCaptura(anulaYReemplaza);
    } else {
      const soloReemplazar = this.rolesOperadores || !this.rolesOperadores && this.aerovaleDetalle.estado === 'Anulado' || reemplazaSupervisor;
      const modalRef = this.modalService.open(ModalConfirmComponent, { centered: true });
      modalRef.componentInstance.mensaje = this.messageWaning(soloReemplazar ? 'Reemplaza' : 'Anula')
      modalRef.result.then(() => {
        if (soloReemplazar) {
          this.procesandoSolicitud = true;
          this.soloReemplazar = true; // en este caso. los reemplazos son directos, sin anulacion
          this.solicitaRefacturacion = true; // lo voy a usar para cambiar la del reemplazo
          this.iniciarFlujoDeCaptura(true);
        } else {
          this.emitirRefacturacionPorDespacho();
        }
      });
    }
  }

  iniciarFlujoDeCaptura(anulaYReemplaza: boolean) {
    this.aerovaleDetalleComponent.mostrarImagenAnulado = anulaYReemplaza;
    this.changeDetector.detectChanges();

    setTimeout(() => {
      this.capturarAerovaleAnulado();
      if (anulaYReemplaza) {
        this.aerovaleDetalleComponent.mostrarImagenAnulado = false;
        this.changeDetector.detectChanges();
      }
    }, 1000);
  }

  capturarAerovaleAnulado() {
    const elemento = this.aerovaleDetalleComponent!.getPrintElement();
    if (!elemento) return;
  
    html2canvas(elemento, {
      allowTaint: false,
      useCORS: true
    }).then(canvas => {
      canvas.toBlob( () => {
        const base64 = canvas.toDataURL("image/jpg");
        this.uploadImage(base64);                            
      },'image/jpg');
    });
  }

  async uploadImage(b64img: string) {
    const archivo:string='AevAnulado_'+this.aerovaleDetalle.id+'.jpg'
    const file = await this.urltoFile(b64img,archivo,this.base64MimeType(b64img));

    // autosave
    /*const blob = new Blob([file], { type: 'application/jpg;' });
      saveAs(blob, 'AevAnulado_'+this.aerovaleDetalle.id+'.jpg');*/
    this.openModal(file);
  }
  
  //return a promise that resolves with a File instance
  urltoFile(url, filename, mimeType){
      return (fetch(url)
          .then(function(res){return res.arrayBuffer();})
          .then(function(buf){return new File([buf], filename,{type:mimeType});})
      );
  }
  
  //return mime Type of bs64
  base64MimeType(encoded) {
      let result = null;
    
      if (typeof encoded !== 'string') {
        return result;
      }
    
      const mime = encoded.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);
    
      if (mime && mime.length) {
        result = mime[1];
      }
    
      return result;
  }

  openModal(file) {
    this.spinner.hide('spinnerDetalle');
    let modalRef;
    if(file != undefined) {
      switch (this.aerovaleDetalle.tipoAerovale) {
        case TipoAerovale.Combustible:
            modalRef = this.modalService.open(AerovaleUpdatedCommonComponent, { centered: true, size: 'lg', backdrop: 'static' });
          break;
        case TipoAerovale.Aeroespecialidad:
            modalRef = this.modalService.open(AerovaleUpdatedCommonComponent, { centered: true, size: 'lg', backdrop: 'static' });
          break;
        case (TipoAerovale.Aerocombustible):
            modalRef = this.modalService.open(AerovaleUpdatedAerocombustibleComponent, { centered: true, size: 'lg', backdrop: 'static' });
          break;
        case (TipoAerovale.Alije):
            modalRef = this.modalService.open(AerovaleUpdatedAlijeComponent, { centered: true, size: 'lg', backdrop: 'static' });
          break;
        default:
          this.messageService.showErrorMessage("El tipo aerovale "+TipoAerovale[this.aerovaleDetalle.tipoAerovale]+" no puede modificarse.");
          break;
      }
      this.capturandoAevAnulado = false;
      this.procesandoSolicitud = false;
      modalRef.componentInstance.aerovaleReemplaza = this.aerovaleDetalle;
      modalRef.componentInstance.fileAerovaleFisico = file;
      modalRef.componentInstance.soloReemplazar = this.soloReemplazar;
      modalRef.componentInstance.solicitaRefacturacion = this.solicitaRefacturacion;
      modalRef.result.then((result) => {
        if(result) {
          this.fileAerovaleFisico=null;
          this.onSelect(this.aerovaleActual);
        }
      });
    }else{
      this.messageService.showErrorMessage("El archivo no se capturo correctamente, vuelva intentarlo.");
      this.capturandoAevAnulado = false;
      this.procesandoSolicitud = false;
    }    
  }

  mostrarFactura(content) {
      this.modalService.open(content, { centered: true, size: 'xl' });
  }

  puedeRegenerarAerovaleServicioIATA(id) {
    this.aerovaleService.puedeRegenerarAerovaleServicio(id).subscribe(puedeRegenerar => {
      this.mostrarRegenerarIATA = puedeRegenerar ?? false;
      this.obtenerComprobanteIdPorAerovaleId(id);
    })
  }

  obtenerComprobanteIdPorAerovaleId(id: string) {
    this.importeFactura == null;

    this.obteniendoComprobante = true;    
    this.comprobanteService.obtenerComprobanteIdSegunAerovale(id)
      .subscribe(result => {
        this.importeFactura = result;

        if (result == null) {
          this.botonAnular = true;
          this.mostrarBotonFacturarAerovale = (this.aerovaleDetalle.estado != "Anulado" && this.aerovaleDetalle.tipoAerovale != TipoAerovale.Devolucion);
          this.obteniendoComprobante = false;
        } else {
          this.mostrarBotonFacturarAerovale = (!this.importeFactura.facturado) && this.aerovaleDetalle.estado != "Anulado" && this.aerovaleDetalle.tipoAerovale != TipoAerovale.Devolucion; 
          this.obtenerComprobantePorId(this.importeFactura.facturaId);
        }
      }, () => {
        this.botonAnular = true;
        if(this.aerovaleDetalle) {
          this.mostrarBotonFacturarAerovale = (this.aerovaleDetalle.estado != "Anulado" && this.aerovaleDetalle.tipoAerovale != TipoAerovale.Devolucion);
        }        
        this.obteniendoComprobante = false;
      });
  }

  obtenerComprobantePorId(id: string) {    
    this.comprobanteService.obtenerComprobantePorId(id)
      .subscribe(result => {        
        this.facturaObtenida = result; //obtengo el comprobante segun id
        this.obteniendoComprobante = false;
      });
  }

  obtenerAerovalePorId(id: string) {    
    this.aerovaleDetalle = null;
    this.aerovaleService.getAerovalePorIdyTipo(id)
      .subscribe(aerovaleDetalle => {
        this.aerovaleDetalle = aerovaleDetalle;
      });
  }

  onNuevoAerovaleCancelado() {
    this.tipoNuevoAerovale = null;
    this.buscarDesdeHasta();
  }

  onNuevoAerovaleCreado(aerovale) {
    if(aerovale != null){
      this.tipoNuevoAerovale = null;
      this.messageService.showSuccessMessage("Aerovale creado exitosamente.");
      this.buscarDesdeHasta();
    }    
  }

  verRemito() {
    if (this.remitoFox.numeroFox != 0 && this.remitoFox.prefijoFox != 0 && this.remitoFox.numeroFox != null && this.remitoFox.prefijoFox != null) {
      const modalRef = this.modalService.open(VisorRemitoAerovaleComponent, { centered: true, size: 'lg' });
      modalRef.componentInstance.aerovaleDetalle = this.aerovaleDetalle;
      modalRef.componentInstance.aerovale = this.aerovaleActual;
      modalRef.componentInstance.remitoFox = this.remitoFox;
      // modalRef.componentInstance.remitoObtenido = this.remitoObtenido;
    } else {
      const modalRef = this.modalService.open(ModalCreacionFoxComponent, { centered: true });
      modalRef.componentInstance.remitoFox = this.remitoFox;
      modalRef.result.then((result) => {
        if (result) {
          this.verRemito();
        }
      });
    }
  }

  obtenerRemitos() {
    this.buscandoComprobante = true;
    if (this.aerovaleActual != null) {
      this.comprobanteService.getRemitoAerovale(this.aerovaleActual.id)
        .subscribe(result => {
          this.remitoFox = result;
          this.buscandoComprobante = false;
          this.puedeRegenerarAerovaleServicioIATA(this.aerovaleDetalle.id);
        }, () => {
          this.messageService.showErrorMessage('Hubo un error al obtener el remito de facturación');
          this.buscandoComprobante = false;
          //Se cambia el lugar de la llamada porque si se llaman los dos endpoints de facturacion en el ngOnInit se duplicaba el aerovale
          this.puedeRegenerarAerovaleServicioIATA(this.aerovaleDetalle.id);
        });
    }
  }

  logicaParaMostrarBotonAnularAerovaleOk(){
    if(this.aerovaleDetalle.estado == 'Anulado'){
      return false;
    }

    if(this.aerovaleDetalle.estado == "DespachoIniciado" || this.aerovaleDetalle.estado == "DespachoFinalizado" || this.aerovaleDetalle.estado == "Pendiente"){
      return true;
    }

    if(this.aerovaleDetalle.estado == "FinalizadoSinFirma" || this.aerovaleDetalle.estado == "Finalizado" || this.aerovaleDetalle.estado == "Sincronizado"){
      /*Si es FinSinFirma, FinConFirma o sincronizado chequear que esta facturado.
	    Que este facturado significa que al obtener obtenerComprobanteIdPorAerovaleId, el atributo facturado del dto respuesta
      sea true y tener atributo facturaId != null. 
      */
      if(this.importeFactura == null || (this.importeFactura.facturaId != null && this.importeFactura.estado != EstadoFactura.Emitido)){
        return true;
      }
    }

    return false;
  }

  /**
   * getter solicitud de refacturación
   */

  mapFormToDto(): RefacturacionFactura {
    const refacturacion = new RefacturacionFactura();
    refacturacion.detalle = 'Refacturación por corrección de despacho';
    refacturacion.usuarioSolicitador = this.obtenerStringUsuarioSolicitador();
    return refacturacion;
  }
  
  obtenerStringUsuarioSolicitador(){
    return this.facturacionService.obtenerStringSolicitador();
  }
  
  emitirRefacturacionPorDespacho() {
    const refacturacion = this.mapFormToDto();
    refacturacion.estado = 0;
    refacturacion.aerovaleId = this.aerovaleDetalle.id;
    refacturacion.responsable = this.obtenerStringUsuarioSolicitador();
    refacturacion.aerovaleReemplazoDTO = null; // si es null ANULA, de lo contrario REEMPLAZA
    this.procesandoAnulacion = true;
    this.facturacionService.emitirSolicitarRefacturacionPorDespacho(refacturacion)
      .subscribe(
        () => {
          this.messageService.showSuccessMessage('Se ha realizado correctamente la solicitud de refacturación.');
          this.procesandoAnulacion = false;
          this.onSelect(this.aerovaleActual);
        },
        (err: ErrorModel) => {
          this.messageService.showErrorMessage(err.message + '\n' + err.description);
          this.procesandoAnulacion = false;
        }
      );
  }
  
  messageWaning(tipoSolicitud: 'Anula' | 'Reemplaza'): string {
    let mensaje = "";
    if (tipoSolicitud === 'Anula') {
      mensaje = 'Este aerovale ya ha sido facturado. Para continuar con la anulación es necesario solicitar una refacturación. ¿Desea continuar?';
    } else {
      mensaje = 'Este aerovale ya ha sido facturado. Para reemplazarlo es necesario solicitar una refacturación. ¿Desea continuar?';
    }
    return mensaje;
  }

  get puedeRegenerarAerovaleServicio(): boolean {
    return this.authService.hasRole(TipoUsuario.COMERCIAL, TipoUsuario.COMERCIAL_LN, TipoUsuario.COMERCIAL_AV, TipoUsuario.SOPORTE) && this.aerovaleDetalle.estado !== "Anulado";
  }

  get rolesPuedenReemplazar(): boolean {
    return this.authService.hasRole(TipoUsuario.SUPERVISOR, TipoUsuario.RESPRODUCTO, TipoUsuario.TUTOR, TipoUsuario.MANDATARIO, TipoUsuario.OPERADORDIRECTO);
  }

  get rolesPuedenAnularYReemplazar(): boolean {
    return this.authService.hasRole(TipoUsuario.SUPERVISOR, TipoUsuario.OPERADOR, TipoUsuario.OPERADOR_3, TipoUsuario.JEFEDEAEROPLANTA, TipoUsuario.COMERCIAL_AV);
  }

  get rolesPuedenCrearAerovales(): boolean {
    return this.authService.hasRole(TipoUsuario.SUPERVISOR, TipoUsuario.OPERADOR, TipoUsuario.OPERADOR_3, TipoUsuario.OPERADORDIRECTO, TipoUsuario.MANDATARIO,
                                    TipoUsuario.COMERCIAL, TipoUsuario.COMERCIAL_LN, TipoUsuario.COMERCIAL_AV);
  }

  get puedeVisualizarFactura(): boolean {
    return this.facturaObtenida != null && this.facturaObtenida.factura.estado == EstadoFactura.Emitido;
  }

  get disableSolicitarRefacturacion(): boolean {
    return this.importeFactura.tipoSolicitud != TipoSolicitudRefacturacion.SinSolicitud;
  }

  get rolesSolicitarRefacturacion(): boolean {
    return this.rolesService.isSolicitanRefacturacion;
  }

  get tituloBotonRefacturacion(): string {
    if (this.disableSolicitarRefacturacion) {
      return this.tituloSegunTipoSolicitud;
    }
    return (this.rolesOperadores) ? 'Anular y Reemplazar' : (this.aerovaleDetalle.estado === 'Anulado') ? 'Reemplazar aerovale' : 'Anular';
  }

  get tituloBotonAnuladoReemplazado(): string {
    if (this.disableSolicitarRefacturacion) {
      return this.tituloSegunTipoSolicitud;
    }
    return 'Anular y Reemplazar';
  }

  get tituloSegunTipoSolicitud(): string {
    switch (this.importeFactura.tipoSolicitud) {
      case TipoSolicitudRefacturacion.Reemplazo:
        return  'Solicitud de reemplazo pendiente'      
      case TipoSolicitudRefacturacion.Anulacion:
        return  'Solicitud de anulación pendiente'      
      case TipoSolicitudRefacturacion.Manual:
        return  'Solicitud de refacturación pendiente'      
      default:
        return 'Sin solicitud'
    }
  }

  get rolesOperadores(): boolean {
    return this.authService.hasRole(TipoUsuario.OPERADOR_3, TipoUsuario.OPERADORDIRECTO);
  }
}
